(ns common.furnace-patterns
  (:require [clojure.math    :as math]
            [clojure.string  :as str]
            [taoensso.timbre :as timbre])
  #?(:clj (:import [java.util Calendar])))

(defn- get-decade [year] (* (math/floor-div (mod year 100) 10) 10))
(defn- get-century [year] (* (math/floor-div year 100) 100))

(defn get-current-year
  []
  #?(:clj
     (let [calendar     (Calendar/getInstance)
           current-year (.get calendar Calendar/YEAR)]
       current-year)

     :cljs
     (let [now          (js/Date.)
           current-year (.getFullYear now)]
       current-year)))

(defn guess-year-of-manufacture-from-year-code
  "Given an unprocessed-year-code, guess the year it actually means using 'common sense'.
   Basically, assume the code represents the last few digits of the year."
  [{:keys [min-year-used max-year-used] :as _pattern} year-code]
  (when-some [parsed (parse-long year-code)]
    (let [current-year (get-current-year)
          min-decade (some-> min-year-used get-decade)
          max-decade (some-> max-year-used get-decade)
          unit-yr (mod parsed 10)
          decade (case (count year-code)
                   2 (get-decade parsed) ;; YY, so just use it directly
                   1 (if (or (and min-decade max-decade (= min-decade max-decade))
                             min-decade)
                       min-decade
                       (timbre/log "Can't guess decade from" year-code)))
          century (case (count year-code)
                    2 (if (< parsed (- current-year 2000))
                        2000 ;; if YY is less than current-year, it's modern
                        1900)
                    1 (if (or (and min-decade max-decade (= min-decade max-decade))
                              min-decade)
                        (get-century min-year-used)
                        (timbre/log "Can't guess century from" year-code)))]
      (str (+ century decade unit-yr)))))

(defn pattern-belongs-to-manufacturer?
  [manufacturer {:keys [manufacturers] :as _pattern}]
  (contains? (set manufacturers) manufacturer))

(defn extract-possible-years-of-manufacture
  "Extract possible years of manufacture, given the serial number, make and pattern."
  [make serial-number {:keys [encoded-regex lookup] :as pattern}]
  (when (and make serial-number pattern)
    (let [width-without-spaces   (count (str/replace serial-number #"\s+" ""))
          year-code              (when-some [extracted-code
                                             (some-> (re-pattern encoded-regex)
                                                     (re-matches serial-number)
                                                     (rest)
                                                     (not-empty))]
                                   (str/join "" extracted-code))
          possible-YOMs-from-LUT (get-in lookup [:table year-code])]
      (when (and (pattern-belongs-to-manufacturer? make pattern)
                 (= width-without-spaces (:width-without-spaces pattern))
                 year-code)
        (or possible-YOMs-from-LUT
            (conj #{} (guess-year-of-manufacture-from-year-code pattern year-code)))))))

(defn make+serial->possible-years-of-manufacture
  "Extracts year(s) of manufacture from the given serial number and make, using
   the compiled-patterns. Returns possible years as a set."
  [make->compiled-patterns make serial-number]
  (let [possible-patterns (get make->compiled-patterns make)
        possible-YOMs (into #{}
                            (comp
                             (map (partial extract-possible-years-of-manufacture make serial-number))
                             (remove not)
                             cat)
                            possible-patterns)]
    possible-YOMs))
